import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GrowthBookService } from '../growthbook.service';
import { switchMap, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'cl-feature-hide',
  template: `<ng-container *ngIf="(show$ | async) ?? default === 'show'"
    ><ng-content></ng-content
  ></ng-container>`,
  styles: [],
  encapsulation: ViewEncapsulation.Emulated,
})
export class FeatureHideComponent implements OnDestroy {
  active = true;
  @Input()
  set featureKey(key: string) {
    this.featureKey$.next(key);
  }
  get featureKey(): string {
    return this.featureKey$.value;
  }
  @Input() default: 'show' | 'hide' = 'hide';

  featureKey$ = new BehaviorSubject<string>('');

  show$ = this.featureKey$.pipe(
    switchMap((key) => this.service.featureIsOff(key)),
    takeWhile(() => this.active)
  );

  ngOnDestroy() {
    this.active = false;
  }

  constructor(private service: GrowthBookService) {}
}
